export const PHONE_LENGTH_RU = 11;
export const PHONE_LENGTH_BY_AZ = 12;

export const formatPhoneInput = (raw: string): string => {
  const trimmed = raw.trim();
  let cleaned = raw.replace(/\D/g, '');


  if (cleaned.startsWith('994')) {
    if (cleaned.length > PHONE_LENGTH_BY_AZ) {
      cleaned = cleaned.substring(0, PHONE_LENGTH_BY_AZ);
    }
    let formatted = '+994';
    if (cleaned.length > 3) {
      formatted += ' (' + cleaned.substring(3, 5);
    }
    if (cleaned.length > 5) {
      formatted += ') ' + cleaned.substring(5, 8);
    }
    if (cleaned.length > 8) {
      formatted += '-' + cleaned.substring(8, 10);
    }
    if (cleaned.length > 10) {
      formatted += '-' + cleaned.substring(10, 12);
    }
    return formatted;
  }


  if (
    trimmed.startsWith('+') &&
    cleaned.startsWith('9') &&
    !cleaned.startsWith('79') &&
    !cleaned.startsWith('994')
  ) {
    return `+${cleaned}`;
  }


  if (cleaned.startsWith('3')) {
    if (!cleaned.startsWith('375')) {
      cleaned = '375' + cleaned.slice(1);
    }
    if (cleaned.length > PHONE_LENGTH_BY_AZ) {
      cleaned = cleaned.substring(0, PHONE_LENGTH_BY_AZ);
    }
    let formatted = '+375';
    if (cleaned.length > 3) {
      formatted += ' (' + cleaned.substring(3, 5);
    }
    if (cleaned.length > 5) {
      formatted += ') ' + cleaned.substring(5, 8);
    }
    if (cleaned.length > 8) {
      formatted += '-' + cleaned.substring(8, 10);
    }
    if (cleaned.length > 10) {
      formatted += '-' + cleaned.substring(10, 12);
    }
    return formatted;
  }


  if (!cleaned) {
    return '';
  }
  if (cleaned[0] === '8') {
    cleaned = '7' + cleaned.slice(1);
  }
  if (cleaned[0] !== '7') {
    cleaned = '7' + cleaned;
  }
  if (cleaned.length > PHONE_LENGTH_RU) {
    cleaned = cleaned.substring(0, PHONE_LENGTH_RU);
  }

  let formatted = '+7';
  if (cleaned.length > 1) {
    formatted += ' (' + cleaned.substring(1, 4);
  }
  if (cleaned.length > 4) {
    formatted += ') ' + cleaned.substring(4, 7);
  }
  if (cleaned.length > 7) {
    formatted += '-' + cleaned.substring(7, 9);
  }
  if (cleaned.length > 9) {
    formatted += '-' + cleaned.substring(9, 11);
  }
  return formatted;
};

export const validatePhone = (phone: string): string | null => {
  const digits = phone.replace(/\D/g, '');
  if (!digits) {
    return 'Введите телефон';
  }
  if (digits.startsWith('994')) {
    return digits.length === PHONE_LENGTH_BY_AZ
      ? null
      : 'Азербайджанский номер: +994 XX XXX XX XX (12 цифр)';
  }
  if (digits.startsWith('375')) {
    return digits.length === PHONE_LENGTH_BY_AZ
      ? null
      : 'Белорусский номер: +375 (XX) XXX-XX-XX (12 цифр)';
  }
  if (digits.length === PHONE_LENGTH_RU && digits.startsWith('7')) {
    return null;
  }
  if (digits.length === 10) {
    return null;
  }
  return 'Введите корректный телефон (+7, +375 или +994)';
};
